import React from 'react';
import PropTypes from 'prop-types';


import * as heroConstants from './heroConstants';
import * as styleUtils from '../../../utils/styleUtils';

import styles from './Hero.scss';


function Hero({children, image}) {

    return (
        <div className={styleUtils.toClasses(styles.hero, styles[image], 'container')}>
            <div className={styleUtils.toClasses(styles.wrap, 'row')}>
                <div className={styles.inner}>
                    {children}
                </div>
            </div>
        </div>
    );
}


Hero.propTypes = {
    children: PropTypes.any,
    image: PropTypes.oneOf(heroConstants.HERO_IMAGES).isRequired
};

Hero.defaultProps = {};


export default Hero;
